/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
  DeleteApiV1TutoraiDocumentsDocumentidPathParams,
  DeleteApiV1TutoraiDocumentsDocumentid401,
  DeleteApiV1TutoraiDocumentsDocumentid404,
  DeleteApiV1TutoraiDocumentsDocumentid500,
} from "../../types/tutorAIDocumentosController/DeleteApiV1TutoraiDocumentsDocumentid.ts";

function getDeleteApiV1TutoraiDocumentsDocumentidUrl(
  documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/tutorai/documents/${documentId}` as const,
  };
  return res;
}

/**
 * @description Remove o documento por completo: arquivo no storage, embeddings e registro. Operação irreversível. **(Requer Authorization para autenticação)**
 * @summary Deletar documento (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents/:documentId}
 */
export async function deleteApiV1TutoraiDocumentsDocumentid(
  documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1TutoraiDocumentsDocumentid401
      | DeleteApiV1TutoraiDocumentsDocumentid404
      | DeleteApiV1TutoraiDocumentsDocumentid500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1TutoraiDocumentsDocumentidUrl(documentId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
